import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Ho4ArticleSidebar from '../components/Ho4ArticleSidebar';
import { HO4_LAST_MODIFIED } from '../data/ho4Articles';

function Ho4WaterDamageArticlePage() {
  const navigate = useNavigate();
  const articleLinkStyle = { color: '#065F46', fontWeight: 600, textDecoration: 'underline' };

  useEffect(() => {
    const previousTitle = document.title;
    const descriptionMeta = document.querySelector('meta[name="description"]');
    const previousDescription = descriptionMeta?.getAttribute('content') ?? '';
    document.title = 'Does HO-4 Cover Water Damage and Leaks? | GetSkimp';
    if (descriptionMeta) {
      descriptionMeta.setAttribute('content', 'Learn when HO-4 renters insurance may cover water damage and leaks, plus common exclusions to watch for.');
    }
    return () => {
      document.title = previousTitle;
      if (descriptionMeta) descriptionMeta.setAttribute('content', previousDescription);
    };
  }, []);

  return (
    <div className="container">
      <div style={{ display: 'grid', gridTemplateColumns: '260px 1fr', gap: '2rem' }}>
        <Ho4ArticleSidebar
          activeHref="/knowledge-base/does-ho4-cover-water-damage"
          onNavigate={(href) => navigate(href)}
        />
        <section>
          <div style={{ marginBottom: '1rem' }}>
            <button type="button" className="btn btn-sm btn-outline" onClick={() => navigate('/knowledge-base')} style={{ marginBottom: '1rem' }}>
              Back to self help library
            </button>
            <h2 style={{ marginBottom: '0.5rem' }}>Does HO-4 cover water damage and leaks?</h2>
            <p style={{ marginBottom: 0, color: '#4B5563' }}>Some water losses may be covered, but source and cause of damage are key.</p>
            <p style={{ marginTop: '0.5rem', fontSize: '0.85rem', color: '#6B7280' }}>Last modified: {HO4_LAST_MODIFIED}</p>
          </div>

          <article className="card mb-4"><div className="card-body">
            <h3 style={{ marginBottom: '0.75rem' }}>Quick answer</h3>
            <p>HO-4 often covers certain sudden and accidental water losses to personal property, but not every type of water event. Flood and long-term maintenance issues are commonly excluded.</p>
            <h3 style={{ marginBottom: '0.75rem', marginTop: '1.5rem' }}>Common distinctions</h3>
            <ul style={{ paddingLeft: '1.2rem', marginBottom: 0 }}>
              <li style={{ marginBottom: '0.5rem' }}>Sudden accidental leak events may be covered.</li>
              <li style={{ marginBottom: '0.5rem' }}>Gradual damage and neglect are often not covered.</li>
              <li style={{ marginBottom: '0.5rem' }}>Flood losses usually require separate coverage.</li>
              <li>Coverage still depends on your policy language and endorsements.</li>
            </ul>
            <p style={{ marginTop: '1rem', marginBottom: 0 }}>
              Before purchase, compare <Link to="/knowledge-base/how-much-liability-do-i-need-for-renters-insurance" style={articleLinkStyle}>liability limits</Link>, <Link to="/knowledge-base/what-deductible-should-i-choose-for-ho4" style={articleLinkStyle}>deductibles</Link>, and your full HO-4 setup in <Link to="/knowledge-base/what-is-ho4-renters-insurance" style={articleLinkStyle}>this guide</Link>.
            </p>
          </div></article>

          <section className="card mb-4" style={{ borderColor: 'var(--color-green)', background: 'linear-gradient(135deg, #ECFDF5 0%, #FFFFFF 100%)', boxShadow: 'var(--shadow-md)' }}>
            <div className="card-body">
              <h3 style={{ marginBottom: '0.5rem', color: '#065F46' }}>Start renters insurance with GetSkimp</h3>
              <p style={{ marginBottom: '1rem' }}>Build an HO-4 policy that matches your building and risk profile.</p>
              <button type="button" className="btn btn-primary" onClick={() => navigate('/qualify')} style={{ fontWeight: 700, paddingInline: '1.4rem' }}>Get started now</button>
            </div>
          </section>
          <section className="card" style={{ borderColor: '#FBBF24', background: 'linear-gradient(135deg, #FFFBEB 0%, #FFFFFF 100%)' }}>
            <div className="card-body">
              <h3 style={{ marginBottom: '0.5rem', color: '#92400E' }}>Need help with water coverage questions?</h3>
              <p style={{ marginBottom: '1rem' }}>An agent can walk you through common water-loss scenarios and exclusions.</p>
              <button type="button" className="btn btn-outline" onClick={() => navigate('/help')} style={{ borderColor: '#D97706', color: '#92400E', fontWeight: 700 }}>Speak to an agent</button>
            </div>
          </section>
        </section>
      </div>
    </div>
  );
}

export default Ho4WaterDamageArticlePage;

